import {watch} from "vue";

// true once source.value is set (e.g. Clerk's signIn, ready only once Clerk has loaded, which can
// take ~10 s), false after timeoutMs
export function waitForValue(source, timeoutMs = 30000) {
  if (source.value) return Promise.resolve(true);
  return new Promise((resolve) => {
    let stop = () => {};
    const timer = setTimeout(() => {
      stop();
      resolve(false);
    }, timeoutMs);
    stop = watch(source, (value) => {
      if (!value) return;
      clearTimeout(timer);
      stop();
      resolve(true);
    });
  });
}
